import {type ApiGetUserData, useApiContext} from '@deezer/react-legacy-api';
import {getLibraryTransferUrl} from '@lib/getLibraryTransferUrl';

const useTmmRedirect = () => {
	const legacyApi = useApiContext();

	return async (
		user: ApiGetUserData | null,
		redirectUrl: string,
		campaign: string,
	): Promise<string | null> => {
		const userId = user?.USER?.USER_ID?.toString();
		const blogName = user?.USER?.BLOG_NAME;

		if (!userId || !blogName) {
			throw new Error('Error user');
		}

		if (user.checkForm) {
			legacyApi.setToken(user.checkForm);
		}

		const token = await legacyApi.call({
			method: 'libraryimport.getTMMAccessToken',
			data: {},
		});

		if (!token) {
			throw new Error('Error token');
		}

		const migrationUrl = await getLibraryTransferUrl(
			userId,
			blogName,
			token as string,
			redirectUrl,
			campaign,
		);

		if (!migrationUrl) {
			throw new Error('Error migrationUrl');
		}

		return migrationUrl;
	};
};

export default useTmmRedirect;
